
import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import TimeMarquee from "./time-marque";
import logo from "../../assets/images/logo.png";
import { fetchNavbar } from "../../services/api";
import { fetchFooter } from "../../services/api";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolledHalf, setScrolledHalf] = useState(false);
  const [navbarItems, setNavbarItems] = useState([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  // ✅ NEW: dynamic circle origin
  const [menuPos, setMenuPos] = useState({ x: "90%", y: "60px" });

  const location = useLocation();
  const lang = location.pathname.startsWith("/ja") ? "ja" : "en";

  const isXL = screenWidth >= 1440;
  const isTablet = screenWidth >= 765 && screenWidth < 1440;
  const isMobile = screenWidth < 765;

  const navImages = [
  "https://saison-capital.staginggportals.com/uploads/large_banner_image_06de3bc09e.jpg",
  "https://saison-capital.staginggportals.com/uploads/large_home_banner_onload_img_882601610e.jpg",
];

const [currentImage, setCurrentImage] = useState(0);
// const path = location.pathname;

// const isJP = path.startsWith("/ja");

// // remove /ja if already present
// const cleanPath = path.replace(/^\/ja/, "") || "/";

// // target paths
// const enPath = cleanPath;
// const jpPath = `/ja${cleanPath}`;
const path = location.pathname;
const isJP = path.startsWith("/ja");
const cleanPath = path.replace(/^\/ja/, "") || "/";

const isArticleDetail = /^(\/ja)?\/articles\/.+/.test(path);
// Check if we're on an article detail page
const articleMatch = cleanPath.match(/^\/articles\/(.+)$/);

// Build en and jp paths
const enPath = articleMatch
  ? `/articles/${articleMatch[1].replace(/^ja-/, "")}`
  : cleanPath;
const jpPath = articleMatch
  ? `/ja/articles/ja-${articleMatch[1].replace(/^ja-/, "")}`
  : `/ja${cleanPath}`;
const [footerData, setFooterData] = useState(null);

useEffect(() => {
  if (!open) return;

  const interval = setInterval(() => {
    setCurrentImage((prev) => (prev + 1) % navImages.length);
  }, 5000);

  return () => clearInterval(interval);
}, [open]);
useEffect(() => {
  fetchFooter(lang).then(setFooterData);
}, [lang]);
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Fetch navbar
  useEffect(() => {
    fetchNavbar(lang).then((data) => {
      if (data?.navbar_list?.length) {
        setNavbarItems(data?.navbar_list);
      } else {
        fetchNavbar("en").then((fallback) =>
          setNavbarItems(fallback?.navbar_list || [])
        );
      }
    });
  }, [lang]);

  // ✅ Scroll ONLY for desktop XL
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const screenHeight = window.innerHeight;

      setScrolledHalf(scrollY > screenHeight / 2);

      if (isXL && scrollY > screenHeight) {
        setOpen(true);
      } else if (isXL) {
        setOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isXL]);

  // ✅ Hamburger click with position capture
  const handleMenuToggle = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMenuPos({
      x: `${rect.left + rect.width / 2}px`,
      y: `${rect.top + rect.height / 2}px`,
    });
    setOpen(!open);
  };

  return (
    <section className="fixed top-0 z-50 w-full nav-px">
      {/* ================= NAVBAR ================= */}
      {/* <nav
        className={`flex justify-between items-center text-white transition-all duration-500 ${
          open && isXL ? "dark-nav" : ""
        }`}
      > */}
      <nav
        className={`flex justify-between items-center text-white transition-all duration-500 ${
          open && isXL ? "" : ""
        }`}
      >
        {/* LOGO */}
        <div className="logo">
        <a href="/"> <svg xmlns="http://www.w3.org/2000/svg" width="70" height="43" viewBox="0 0 70 43" fill="none">
<g clip-path="url(#clip0_11507_1402)">
<path d="M70 0H0V43H70V0Z" fill="#004098"/>
<path d="M68.9785 21.9844H1.03125V41.9672H68.9785V21.9844Z" fill="#009944"/>
<path d="M64.9931 5.00552V14.2161L64.9838 14.1977L57.3594 4.83984V16.9437H58.3811V7.70549L66.0148 17.0756V5.00552H64.9931Z" fill="white"/>
<path d="M48.0432 4.78125C44.6014 4.78125 41.8047 7.56099 41.8047 10.985C41.8047 14.4091 44.6014 17.1857 48.0432 17.1857C51.485 17.1857 54.2817 14.406 54.2817 10.985C54.2817 7.56405 51.4881 4.78125 48.0432 4.78125ZM48.0432 16.1733C45.1601 16.1733 42.8264 13.8507 42.8264 10.9881C42.8264 8.12552 45.1632 5.79987 48.0432 5.79987C50.9232 5.79987 53.2599 8.12552 53.2599 10.9881C53.2599 13.8507 50.9263 16.1733 48.0432 16.1733Z" fill="white"/>
<path d="M48.0484 8.58984C46.7179 8.58984 45.6406 9.66062 45.6406 10.983C45.6406 12.3054 46.7179 13.3731 48.0484 13.3731C49.3788 13.3731 50.4561 12.3023 50.4561 10.983C50.4561 9.66369 49.3726 8.58984 48.0484 8.58984ZM48.0484 12.3575C47.2828 12.3575 46.6624 11.7408 46.6624 10.983C46.6624 10.2252 47.2828 9.60847 48.0484 9.60847C48.8139 9.60847 49.4312 10.2221 49.4312 10.983C49.4312 11.7439 48.817 12.3575 48.0484 12.3575Z" fill="white"/>
<path d="M9.29192 10.7955C8.49552 10.5592 7.58799 10.3353 6.89037 10.1144C6.07236 9.8229 5.48278 9.05586 5.48278 8.15076C5.48278 7.70588 5.62477 7.30088 5.86246 6.96952C6.40882 6.0951 7.6559 5.6625 8.62208 6.0092C9.29192 6.25771 9.83829 6.77316 10.1686 7.35304L11.0236 6.98793C10.6841 6.07056 9.92781 5.34341 8.98324 5.03659C8.20227 4.73285 7.22683 4.76967 6.47056 5.13171C5.23892 5.6134 4.39621 6.81918 4.39621 8.15689C4.39621 9.33813 5.10001 10.3844 6.1094 10.9182C6.84407 11.2404 7.70838 11.4551 8.406 11.6116C9.49874 11.7896 10.4402 12.6057 10.4402 13.7256V13.7593C10.4217 15.4284 8.55108 16.4102 7.02619 16.1341C5.92728 15.9009 5.03519 15.1277 4.64007 14.106L3.71094 14.4681C4.14618 15.7352 5.19261 16.7139 6.50452 17.0576C7.80407 17.3981 9.28266 17.0913 10.2735 16.2384C11.0051 15.6616 11.4805 14.7749 11.4805 13.7716C11.4805 12.44 10.5205 11.2281 9.28884 10.7955" fill="white"/>
<path d="M36.8826 10.7955C36.0924 10.5592 35.1817 10.3353 34.481 10.1144C33.6692 9.8229 33.0796 9.05586 33.0796 8.15076C33.0796 7.70588 33.2216 7.30088 33.4593 6.96952C34.0118 6.0951 35.2435 5.6625 36.2189 6.0092C36.8857 6.25771 37.4382 6.77316 37.7654 7.35304L38.6205 6.98793C38.2778 6.07056 37.5339 5.34341 36.5863 5.03659C35.8022 4.73285 34.8268 4.76967 34.0705 5.13171C32.8419 5.6134 31.9992 6.81918 31.9992 8.15689C31.9992 9.33813 32.6968 10.3844 33.7062 10.9182C34.4409 11.2404 35.296 11.4551 36.0028 11.6116C37.0925 11.7896 38.0371 12.6057 38.0371 13.7256V13.7593C38.0185 15.4284 36.151 16.4102 34.623 16.1341C33.5272 15.9009 32.6351 15.1277 32.2369 14.106L31.3047 14.4681C31.743 15.7352 32.7925 16.7139 34.1044 17.0576C35.404 17.3981 36.8857 17.0913 37.8704 16.2384C38.6019 15.6616 39.0773 14.7749 39.0773 13.7716C39.0773 12.44 38.1173 11.2281 36.8857 10.7955" fill="white"/>
<path d="M27.3124 5.02734H26.2969V16.9011H27.3124V5.02734Z" fill="white"/>
<path d="M18.3762 4.39062L13.2891 16.9178H14.3911L16.0209 12.8924H20.7314L22.3674 16.9148H23.4632L18.3762 4.39062ZM16.4315 11.88L18.3731 7.09979L20.3178 11.88H16.4315Z" fill="white"/>
<path d="M20.3554 26.2227L15.719 37.6331H16.7222L18.207 33.9666H22.5008L23.9948 37.6331H23.9917H24.9918L20.3585 26.2227H20.3554ZM18.5836 33.0462L20.3554 28.6864L22.1242 33.0462H18.5836Z" fill="white"/>
<path d="M52.3474 26.2227L47.7109 37.6331H48.7142L50.1989 33.9666H54.4927L55.9867 37.6331H55.9836H56.9838L52.3504 26.2227H52.3474ZM50.5755 33.0462L52.3474 28.6864L54.1161 33.0462H50.5755Z" fill="white"/>
<path d="M4.99219 32.2252C4.99219 35.3393 7.54191 37.8675 10.6781 37.8675C11.7986 37.8675 12.8543 37.5423 13.7372 36.99V35.8425C12.9099 36.5329 11.8388 36.9471 10.6781 36.9471C8.05123 36.9471 5.92441 34.8362 5.92441 32.2282C5.92441 29.6203 8.05123 27.5033 10.6781 27.5033C11.8449 27.5033 12.913 27.9267 13.7433 28.617V27.4726C12.8574 26.9142 11.8017 26.5859 10.6781 26.5859C7.54191 26.5859 4.99219 29.111 4.99219 32.2282" fill="white"/>
<path d="M37.4495 26.6484H36.5234V37.6293H37.4495V26.6484Z" fill="white"/>
<path d="M30.7034 26.6523H27.5703V37.6302H28.4964V33.1016H30.7034C32.4938 33.1016 33.9477 31.6565 33.9477 29.877C33.9477 28.0974 32.4969 26.6523 30.7034 26.6523ZM30.7034 32.1719H30.7004H28.4964V27.5697H30.7034C31.9814 27.5666 33.0217 28.5975 33.0217 29.8678C33.0217 31.138 31.9845 32.1689 30.7034 32.1689" fill="white"/>
<path d="M60.4869 36.7058V26.6484H59.5547V37.6324H65.6851V36.7058H60.4869Z" fill="white"/>
<path d="M47.2112 26.6484H40.0312V27.5904H43.1397V37.6324H44.0843V27.5904H47.2112V26.6484Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_11507_1402">
<rect width="70" height="43" fill="white"/>
</clipPath>
</defs>
</svg></a>
        </div>

        {/* RIGHT */}
        <div className="flex items-center  ml-auto gap-6">
          {/* LANGUAGE */}
          {!(open && isXL) && (
            <div className="language-switch flex">
          <NavLink
  to={enPath}
  className={`${!isJP ? "active-lang" : ""} en`}
>
  EN
</NavLink>

<NavLink
  to={jpPath}
  className={`${isJP ? "active-lang" : ""} ja`}
>
  JP
</NavLink>
            </div>
          )}

          {/* DESKTOP NAV */}
          {open && isXL && (
            <div className="hidden xl:flex " style={{ fontSize: "14px" }}>
              {navbarItems.map((item) => (
                <NavLink
                  key={item.id}
                  className="open-nav-links"
                  to={item.navbar_url}
                  onClick={() => setOpen(false)}
                >
                  {item.navbar_text}
                </NavLink>
              ))}
            </div>
          )}

          {/* HAMBURGER */}
          <button
            onClick={handleMenuToggle}
            className="relative flex items-center justify-center"
            style={{ width: "26.25px", height: "17.5px" }}
          >
            <span
              className="absolute transition-all duration-300"
              style={{
                width: "26.25px",
                height: "3px",
                borderRadius: "5px",
                // backgroundColor: open
                //   ? "rgba(188, 226, 245, 1)"
                //   : "rgba(0, 64, 152, 1)",
                   backgroundColor: "rgba(0, 64, 152, 1)",
                transform: open
                  ? "rotate(45deg)"
                  : "translateY(-7px)",
              }}
            />
            <span
              className="transition-all duration-300"
              style={{
                width: "26.25px",
                height: "3px",
                borderRadius: "5px",
                   backgroundColor: "rgba(0, 64, 152, 1)",
                // backgroundColor: open
                //   ? "rgba(188, 226, 245, 1)"
                //   : "rgba(0, 64, 152, 1)",
                opacity: open ? 0 : 1,
              }}
            />
            <span
              className="absolute transition-all duration-300"
              style={{
                width: "26.25px",
                height: "3px",
                borderRadius: "5px",
                   backgroundColor: "rgba(0, 64, 152, 1)",
                // backgroundColor: open
                //   ? "rgba(188, 226, 245, 1)"
                //   : "rgba(0, 64, 152, 1)",
                transform: open
                  ? "rotate(-45deg)"
                  : "translateY(7px)",
              }}
            />
          </button>
        </div>
      </nav>

     {(isTablet || isMobile) && (
  <div
    className="fixed inset-0  z-40 transition-all duration-700 ease-[cubic-bezier(0.77,0,0.175,1)]"
    style={{ backgroundColor:"rgba(188, 226, 245, 1)",
      clipPath: open
        ? `circle(150% at ${menuPos.x} ${menuPos.y})`
        : `circle(0px at ${menuPos.x} ${menuPos.y})`,
    }}
  >
    {/* CLOSE */}
   <button
  onClick={() => setOpen(false)}
  className="absolute top-12 right-8 text-white text-2xl"
>
  <svg
    className="cursor-pointer z-[70]"
    viewBox="0 0 5.777777777777778 4"
    overflow="visible"
    preserveAspectRatio="none"
    width="26"
    height="18"
    data-testid="hamburger-menu-icon-opened"
  >
    <line
      x1="0"
      x2="5.777777777777778"
      y1="0"
      y2="0"
      stroke="rgba(0, 64, 152, 1)"
      strokeWidth="4"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      style={{
        transform: "translateY(2px) rotate(45deg)",
        transformOrigin: "50% 50%",
        transformBox: "fill-box",
      }}
    />

    <line
      x1="0"
      x2="5.777777777777778"
      y1="2"
      y2="2"
      stroke="rgba(0, 64, 152, 1)"
      strokeWidth="4"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      opacity="0"
    />

    <line
      x1="0"
      x2="5.777777777777778"
      y1="4"
      y2="4"
      stroke="rgba(0, 64, 152, 1)"
      strokeWidth="4"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      style={{
        transform: "translateY(-2px) rotate(-45deg)",
        transformOrigin: "50% 50%",
        transformBox: "fill-box",
      }}
    />
  </svg>
</button>

    {/* MENU ITEMS */}
    <div className="flex h-full " style={{padding: "2.5rem"}}>

       {navImages.map((img, index) => (
        <div className="absolute" style={{width:"50%"}}>
    <img
      key={index}
      src={img}
      alt={`nav-image-${index}`}
      className="inset-0 transition-opacity duration-1000 hidden md:block"
      style={{ height: "calc(100dvh - 5rem)", objectFit:"cover", borderRadius:"5px",
        opacity: currentImage === index ? 1 : 0,
      }}
    />
      </div>
  ))}

         {/* <img style={{width:"50%", height: "calc(100dvh - 5rem)", objectFit:"cover", borderRadius:"5px"}}
  src="https://saison-capital.staginggportals.com/uploads/large_banner_image_06de3bc09e.jpg"
  alt="nav-image"
  className="hidden md:block"
/> */}
    <div className="respo-mob-tab-nav flex flex-col items-center md:items-start justify-center h-full w-full md:w-half text-white text-xl">
 
      {navbarItems.map((item) => (
        <NavLink key={item.id} className="open-nav-links" to={item.navbar_url} onClick={() => setOpen(false)}>
          {item.navbar_text}
        </NavLink>
      ))}
    </div>

    {/* ✅ LANGUAGE SWITCH — bottom right of overlay */}
    <div className="absolute bottom-8 right-8 language-switch flex">
      <NavLink to={enPath} className={`${!isJP ? "active-lang" : ""} en` }  >
        EN
      </NavLink>
      <NavLink to={jpPath} className={`${isJP ? "active-lang" : ""} ja`}>
        JP
      </NavLink>
    </div>
    <div className="absolute bottom-8 nav-follow ">

       <div
              className="flex flex-row items-baseline  text-white text-sm"
              style={{ pointerEvents: "auto" }}
            >
              
             
              <span className="uppercase font-light tracking-wide fs-10" style={{color: 'rgba(0, 64, 152, 1)'}}>
          {footerData?.Follow_us_text}
              </span>
                     <a  className="hover:underline" style={{paddingLeft: "10px"}} 
  href={footerData?.linked_in_url?.startsWith("http") ? footerData?.linked_in_url : `https://${footerData?.linked_in_url}`}
  target="_blank" 
  rel="noreferrer"
  dangerouslySetInnerHTML={{ __html: footerData?.svg_linkedin }} 
/>
            
   {/* <a      href="/"
              target="_blank" rel="noreferrer"
              className="hover:underline" style={{paddingLeft: "10px"}}  >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
<path d="M4 2.001C3.99974 2.53143 3.78877 3.04004 3.41351 3.41492C3.03825 3.78981 2.52943 4.00027 1.999 4C1.46857 3.99974 0.959965 3.78877 0.585079 3.41351C0.210194 3.03825 -0.000264966 2.52943 2.50361e-07 1.999C0.000265467 1.46857 0.211233 0.959965 0.586494 0.585079C0.961754 0.210194 1.47057 -0.000264966 2.001 2.50361e-07C2.53143 0.000265467 3.04004 0.211233 3.41492 0.586494C3.78981 0.961754 4.00027 1.47057 4 2.001ZM4.06 5.481H0.0600002V18.001H4.06V5.481ZM10.38 5.481H6.4V18.001H10.34V11.431C10.34 7.771 15.11 7.431 15.11 11.431V18.001H19.06V10.071C19.06 3.901 12 4.131 10.34 7.161L10.38 5.481Z" fill="white"/>
</svg>
              </a> */}
            </div>
            </div>
            </div>
  </div>
)}

      {/* ================= MARQUEE ================= */}
      <div
        className={`transition-opacity duration-500 ${
          scrolledHalf ? "opacity-0" : "opacity-100"
        }`}
      >
        {/* {!open && <TimeMarquee lang={lang} />} */}
        {/* {!open && !isArticleDetail && <TimeMarquee lang={lang} />} */}
      </div>
    </section>
  );
}